import { type IPlayer, type YTPlayerHandle } from "../cards/TimestampController";

export class YTPlayerWrapper implements IPlayer
{
    constructor(private playerHandle: YTPlayerHandle)
    {

    }
    play(): void {
       this.playerHandle.playVideo();
    }
    pause(): void {
       this.playerHandle.pauseVideo();
    }

    getDuration(): number {
        return this.playerHandle.getDuration() * 1000;
    }

    //get current time in MS
    getCurrentTime(): number {
        return this.playerHandle.getCurrentTime() * 1000; //YT videos are in SECONDS
    }
}